import { ReportNumberFormatUtils } from '@cxstudio/reports/utils/report-number-format-utils.service';

app.filter('commaFormat', (reportNumberFormatUtils: ReportNumberFormatUtils) => {
	return (x) => reportNumberFormatUtils.commaFormat(x);
});
